import { render, staticRenderFns } from "./GlobalTrialDialog.vue?vue&type=template&id=e6396930&scoped=true"
import script from "./GlobalTrialDialog.vue?vue&type=script&lang=js"
export * from "./GlobalTrialDialog.vue?vue&type=script&lang=js"
import style0 from "./GlobalTrialDialog.vue?vue&type=style&index=0&id=e6396930&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6396930",
  null
  
)

export default component.exports